import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import {
  UserPlus,
  Building2,
  Handshake,
  CheckSquare,
  Phone,
  Mail,
  FileText,
  FolderKanban,
  CalendarDays,
} from 'lucide-react'
import { features } from '@/shared/config/features'

interface QuickAction {
  label: string
  href: string
  icon: React.ElementType
  featureFlag?: keyof typeof features
}

const quickActions: QuickAction[] = [
  { label: 'Contact', href: '/dashboard/contacts/new', icon: UserPlus, featureFlag: 'contacts' },
  { label: 'Company', href: '/dashboard/companies/new', icon: Building2, featureFlag: 'companies' },
  { label: 'Deal', href: '/dashboard/deals/new', icon: Handshake, featureFlag: 'deals' },
  { label: 'Project', href: '/dashboard/projects/new', icon: FolderKanban, featureFlag: 'projects' },
  { label: 'Event', href: '/dashboard/events/new', icon: CalendarDays, featureFlag: 'events' },
  { label: 'Task', href: '/dashboard/tasks', icon: CheckSquare, featureFlag: 'tasks' },
  { label: 'Call', href: '/dashboard/calls/new', icon: Phone, featureFlag: 'calls' },
  { label: 'Campaign', href: '/dashboard/email', icon: Mail, featureFlag: 'email' },
  { label: 'Document', href: '/dashboard/docs', icon: FileText, featureFlag: 'docs' },
]

/**
 * QuickActionsBar Component
 *
 * Displays a row of quick action buttons for common CRM operations.
 * Actions are filtered based on enabled feature flags.
 */
export function QuickActionsBar() {
  // Filter actions based on enabled features
  const enabledActions = quickActions.filter(
    (action) => !action.featureFlag || features[action.featureFlag]
  )

  if (enabledActions.length === 0) {
    return null
  }

  return (
    <Card>
      <CardContent className="py-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-muted-foreground mr-2">Quick Add:</span>
          <div className="flex flex-wrap gap-2">
            {enabledActions.map((action) => (
              <Button
                key={action.href}
                variant="outline"
                size="sm"
                asChild
                className="h-8"
              >
                <Link to={action.href}>
                  <action.icon className="h-3.5 w-3.5 mr-1.5" />
                  {action.label}
                </Link>
              </Button>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
